<div [formGroup]="parentForm">
  <div class="da-card w-full mb-3">
    <h3 class="card-title">Recommendations</h3>
    
    <div formArrayName="recommendations">
      <div *ngFor="let rec of recommendations.controls; let i=index" [formGroupName]="i" class="rec-item">
        <div class="card-header-actions">
          <div class="title">{{ i === 0 ? '1st' : i === 1 ? '2nd' : i === 2 ? '3rd' : (i+1) + 'th' }} Recommendation</div>
          <div class="actions">
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text" style="color: #ef4444; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;" (click)="removeRecommendation(i)"></button>
          </div>
        </div>

        <div class="file-upload-row" [class.has-file]="rec.get('fileUrl')?.value">
          <ng-container *ngIf="rec.get('fileUrl')?.value; else noRecFile">
            <!-- New Card-style File Tag -->
            <div class="uploaded-file-pill">
              <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
              <div class="file-details">
                <div class="file-name-row">
                  <span class="file-name" (click)="previewFile(rec.get('fileUrl')?.value, 'LOR ' + (i + 1))">
                    LOR_{{ i + 1 }}.pdf
                  </span>
                  <i class="pi pi-check-circle check-icon" style="color: #16a34a;"></i>
                </div>
                <div class="file-meta">Uploaded &middot; autofilled below</div>
              </div>
              <!-- Hidden file input for Replace -->
              <input type="file" #recReplaceInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, recReplaceInput)">
              <button type="button" class="replace-btn" title="Replace" (click)="recReplaceInput.click()">Replace</button>
            </div>
          </ng-container>
          <ng-template #noRecFile>
            <div class="uploaded-file-pill" style="opacity: 0.6;">
              <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
              <div class="file-details">
                <div class="file-name-row">
                  <span class="file-name" style="color: #9ca3af;">LOR {{ i + 1 }} — Not uploaded</span>
                </div>
                <div class="file-meta" style="color: #f97316;"><i class="pi pi-upload" style="font-size: 11px;"></i> No file yet</div>
              </div>
              <input type="file" #recUploadInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, recUploadInput)">
              <button class="replace-btn" (click)="recUploadInput.click()">Upload</button>
            </div>
          </ng-template>
        </div>
        <app-field-error [control]="rec.get('fileUrl')" type="requiredOnly" fieldName="Document" style="margin-bottom: 16px; display: block;"></app-field-error>

        <div class="form-grid">
          <div class="field-group">
            <label>Name <span class="required">*</span></label>
            <input pInputText formControlName="name"
              [class.ng-invalid]="isFieldInvalid(rec, 'name')"
              [class.ng-dirty]="isFieldInvalid(rec, 'name')" />
            <app-field-error [control]="rec.get('name')" type="personName" fieldName="Name"></app-field-error>
          </div>
          <div class="field-group">
            <label>Organisation <span class="required">*</span></label>
            <input pInputText formControlName="organisation"
              [class.ng-invalid]="isFieldInvalid(rec, 'organisation')"
              [class.ng-dirty]="isFieldInvalid(rec, 'organisation')" />
            <app-field-error [control]="rec.get('organisation')" type="alphanumericText" fieldName="Organisation"></app-field-error>
          </div>
          <div class="field-group">
            <label>Official Email <span class="required">*</span></label>
            <input pInputText formControlName="email"
              [class.ng-invalid]="isFieldInvalid(rec, 'email')"
              [class.ng-dirty]="isFieldInvalid(rec, 'email')" />
            <app-field-error [control]="rec.get('email')" type="email" fieldName="Email"></app-field-error>
          </div>
          <div class="field-group">
            <label>Contact Number <span class="required">*</span></label>
            <input pInputText formControlName="contactNumber" maxlength="10"
              [class.ng-invalid]="isFieldInvalid(rec, 'contactNumber')"
              [class.ng-dirty]="isFieldInvalid(rec, 'contactNumber')" />
            <app-field-error [control]="rec.get('contactNumber')" type="mobile10" fieldName="Contact Number"></app-field-error>
          </div>
        </div>

        <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;">
          <button pButton type="button" 
                  [label]="rec.get('id')?.value ? 'Update' : 'Save'"
                  icon="pi pi-check"
                  class="p-button-sm p-button-primary"
                  [loading]="isSavingMap[i]"
                  [disabled]="isSavingMap[i]"
                  style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
                  (click)="saveRecommendation(i)">
          </button>
        </div>
        <div class="unsaved-warning" *ngIf="rec.dirty">
          You have unsaved changes. Please click {{ rec.get('id')?.value ? 'Update' : 'Save' }} to continue.
        </div>

      </div>
    </div>
    
    <div class="add-item-trigger" (click)="addRecommendation()">
      <button class="btn-link">+ Add Another Recommendation</button>
    </div>
  </div>
  
  <p-toast></p-toast>

  <!-- Custom Delete Confirmation Dialog -->
  <p-dialog
    [(visible)]="showDeleteDialog"
    [modal]="true"
    [closable]="!isDeleting"
    [dismissableMask]="!isDeleting"
    [style]="{width: '450px'}"
    styleClass="custom-delete-dialog"
    header="Delete Confirmation">
    <div style="display:flex; align-items:center; gap:16px; justify-content:center; padding: 0.5rem 0;">
      <span style="background:#eef2ff; border-radius:50%; width:60px; height:60px; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;">
        <i class="pi pi-exclamation-triangle" style="font-size:28px; color:#0b0a66;"></i>
      </span>
      <span style="font-size:17px; font-weight:600; color:#000; line-height:1.5;">Are you sure you want to delete this recommender?</span>
    </div>
    <ng-template pTemplate="footer">
      <button pButton
        class="custom-confirm-no"
        label="No"
        icon="pi pi-times"
        (click)="cancelDelete()"
        [disabled]="isDeleting">
      </button>
      <button pButton
        class="custom-confirm-yes"
        [label]="isDeleting ? 'Deleting...' : 'Yes'"
        [icon]="isDeleting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        (click)="confirmDelete()"
        [disabled]="isDeleting">
      </button>
    </ng-template>
  </p-dialog>

  <!-- Shared PDF Preview Dialog -->
  <p-dialog [(visible)]="displayPreviewDialog" [modal]="true" [header]="previewFileName" [dismissableMask]="true"
      [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
      <div class="text-center p-4 relative preview-dialog-body">
          <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="600px" style="border: none;"></iframe>
      </div>
  </p-dialog>
</div>
